import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Box,
  Paper
} from '@mui/material';
import { getAllUsers } from '../../services/api';    // ✅ two levels up                   // ✅ use the helper from api.js

const UserRecords = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getAllUsers()
      .then((res) => {
        setUsers(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch users:', err);
        setError(err.response?.data?.message || 'Failed to load users');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box p={4}>
     
      <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Contact</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell><strong>Address</strong></TableCell>
              <TableCell><strong>Office Address</strong></TableCell>
              <TableCell><strong>Occupation</strong></TableCell>
              <TableCell><strong>Gender</strong></TableCell>
              <TableCell><strong>Emergency Contact</strong></TableCell>
              <TableCell><strong>Email Verified</strong></TableCell>
              <TableCell><strong>Last Login</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user, index) => (
              <TableRow key={user.userId} sx={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                <TableCell>{user.userName}</TableCell>
                <TableCell>{user.userContactNumber}</TableCell>
                <TableCell>{user.userEmail}</TableCell>
                <TableCell>{user.userAddress}</TableCell>
                <TableCell>{user.userOfficeAddress}</TableCell>
                <TableCell>{user.userOccupation}</TableCell>
                <TableCell>{user.userGender}</TableCell>
                <TableCell>{user.userEmergencyContactNumber}</TableCell>
                <TableCell>{user.isUserEmailVerified ? 'Yes' : 'No'}</TableCell>
                <TableCell>{user.lastLoginAt ? new Date(user.lastLoginAt).toLocaleString() : 'N/A'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserRecords;